import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SupervisionManagementDTO } from '../model/supervision-management-dto.model';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';

@Injectable()
export class SupervisionManagementApi extends BaseApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getSmuiData({ offset, limit, searchBy = '', userType = '', bid = 0, year = '', isSupervisorOnly, isActionNeededOnly, ascending } :
        {
            offset: number, 
            limit: number,
            searchBy?:string,
            userType?: string, 
            bid?: number, 
            year?: string, 
            isSupervisorOnly?: boolean,
            isActionNeededOnly?: boolean,
            ascending?: boolean
        }) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('ascending', ascending ? String(ascending): 'false')
            .append('searchBy', String(searchBy))
            .append('userType', String(userType))
            .append('bid', String(bid))
            .append('year', String(year))
            .append('isSupervisorOnly', isSupervisorOnly ? 'true' : 'false')
            .append('isActionNeededOnly', isActionNeededOnly ? 'true' : 'false');

        return this.http.get<SupervisionManagementDTO[]>(this.baseUri + '/SupervisionManagement/Get' , {params});
    }

}
